// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import vueEsign from 'vue-esign';
import store from './store';
import "babel-polyfill";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import iView from 'iview';
import wx from 'weixin-js-sdk';
import 'iview/dist/styles/iview.css';    // 使用 CSS
//import VueI18n from 'vue-i18n'
//import LangEn from '../static/lang/en'
//import LangZh from '../static/lang/zh'
import "./styles/reset.css";
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min';
import phoneRouter from "./router/phone";
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'

import './assets/js/common.js'
Vue.use(ElementUI);
Vue.use(vueEsign);
Vue.use (VueImageSwipe);
Vue.use(wx);
Vue.use(iView);

Vue.config.productionTip = false;
axios.defaults.headers.post['Content-Type'] = 'application/json';
    //Vue.use(VueI18n);

//多语言切换
/*const i18n = new VueI18n({
  locale: 'zhCHS', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages:{
    'en': LangEn,
    'zhCHS': LangZh
  }
})*/

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    //i18n, // 不要忘记
    components: { App },
    template: '<App/>',
    beforeCreate() {
        var self = this,
            data = {
                username: "system@akso.com",
                password: "123123",
                refreshtoken: '0'
            };
            axios.post("https://api.lotusdata.com/v1/buser/token", data, {}).then(
            function(res) {
                if (res.data.code == "0") {
                    // console.log(res,'11111111111111')
                    var token = res.data.token,
                        eltoken = 'JWT ' + token;
                        // console.log(eltoken);
                    //  self.$store.commit('setToken', token);
                     localStorage.setItem("TOKEN", eltoken);
                }
            },
            function(err) {
                self.$Message.error(err);
            }
        )
        var datas =  {
            username: "system",
            password: "Aksosystem",
            refreshtoken: '0'
            };
            axios.post("https://org.api.lotusdata.com/operations/v1/admlogin/token",
                datas).then(
                function (res) {
                if(res.data.code == "0"){
                    var token = res.data.token;
                    // console.log(token);
                    self.token = 'JWT ' + token;
                    self.$store.commit('setToken', token)
                }
                },function (err) {
                self.$Message.error(err);
                }
            )
    }
})



// WEBPACK FOOTER //
// ./src/main.js